// extracted by mini-css-extract-plugin
module.exports = {"modal":"Lightbox-module--modal--s89Jg","tag":"Lightbox-module--tag--3mzUh","image":"Lightbox-module--image--1AXGS","imageWrapper":"Lightbox-module--imageWrapper--Fazej"};